<template>
    <div class="container mt-3">
        <div class="col-md-12 p-0">
            <div class="card">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'admin',
}
</script>